import { AsyncPipe, KeyValuePipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormFieldNewComponent, SdvorCheckboxComponent, SdvorRadioComponent, SwitchComponent } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { SdvorAdditionalOptionsComponent } from './additional-options.component';

@NgModule({
  declarations: [SdvorAdditionalOptionsComponent],
  exports: [SdvorAdditionalOptionsComponent],
  imports: [
    NgIf,
    AsyncPipe,
    NgClass,
    KeyValuePipe,
    NgTemplateOutlet,
    ReactiveFormsModule,
    FormFieldNewComponent,
    IconModule,
    NgbTooltipModule,
    SdvorRadioComponent,
    SdvorCheckboxComponent,
    SwitchComponent,
  ],
})
export class SdvorAdditionalOptionsModule {}
